import { render, staticRenderFns } from "./studyText.vue?vue&type=template&id=0371d3a0&scoped=true&"
import script from "./studyText.vue?vue&type=script&lang=js&"
export * from "./studyText.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&"
import style1 from "./studyText.vue?vue&type=style&index=1&id=0371d3a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0371d3a0",
  null
  
)

export default component.exports